import React    from 'react';

export const Container = props => {
    return (
        <div className="application-header-container">
            { props.children }
        </div>
    );
}
 
export default Container;